module.exports = __webpack_public_path__ + "img/starpets.48895df7.png";